import NextImage from 'next/image'
import Link from 'next/link'

type OwnProps = {
  variant?: LogoVariantType
  position?: LogoPositionType
}
type LogoVariantType = 'default' | '60' | '60_nr'
type LogoPositionType = 'header' | 'footer'

const Logo = ({ variant = 'default', position = 'header' }: OwnProps) => {
  let logoSrc = '/logo.png'

  // Regular 60
  if (variant === '60') {
    logoSrc = position === 'footer' ? '/logo-60-footer.png' : '/logo-60.png'
  }

  // 60 NR edition
  else if (variant === '60_nr') {
    // Footer will take the regular "60" logo
    logoSrc = position === 'footer' ? '/logo-60-footer.png' : '/logo-60-nr.png'
  }

  // Default Nastro Rosa logo: header-only asset
  else if (position === 'header') {
    logoSrc = '/logo-nastro-rosa.png'
  }

  function getLogoInitialSize() {
    // https://nextjs.org/docs/pages/api-reference/components/image#width
    // […] used to infer the correct aspect ratio of the image
    // […] does not determine the rendered size of the image
    // […] the rendered size in the browser, […] will be determined by the parent container
    // The logos can have different aspect ratios, so here's their sizes
    if (variant === '60') {
      if (position === 'footer') {
        return {
          width: 1031,
          height: 1001,
        }
      }

      if (position === 'header') {
        return {
          width: 1182,
          height: 1182,
        }
      }
    } else if (variant === '60_nr') {
      if (position === 'header') {
        return {
          // Actual sizes of the file,
          // for next Image's aspect ratio calculations
          width: 400,
          height: 232,
        }
      }
    } else if (position === 'header') {
      return {
        // Intrinsic size of logo-nastro-rosa.png
        width: 2000,
        height: 1660,
      }
    } else {
      return {
        // The generic default variant,
        // intrinsic size of logo.png
        width: 295,
        height: 432,
      }
    }
  }

  return (
    <div
      className='airc-logo'
      data-variant={variant}
      data-position={position}
    >
      <Link href='/'>
        <NextImage
          src={logoSrc}
          alt='Logo'
          sizes='100vw'
          className='airc-logo__image'
          {...getLogoInitialSize()}
        />
      </Link>
    </div>
  )
}

export default Logo
